// extracted by mini-css-extract-plugin
export default {"uploadButton":"UploadButton_uploadButton__s4sC1","uploadInput":"UploadButton_uploadInput__FULwJ"};